import { ChevronDownIcon } from "@heroicons/react/24/outline";



export function LoadMoreNotifications({ handleLoadMoreNotifications }) {

    return (
        <div onClick={handleLoadMoreNotifications} className="hover:cursor-pointer text-grayP text-sm flex justify-center py-4">
            <div>
                Ver notificaciones anteriores
                <div className="flex justify-center">
                    <ChevronDownIcon className="w-4 h-auto" />
                </div>
            </div>
        </div>
    )

}